import { render } from "./Submit.vue?vue&type=template&id=7143ec35&scoped=true"
import script from "./Submit.vue?vue&type=script&lang=js"
export * from "./Submit.vue?vue&type=script&lang=js"

import "./Submit.vue?vue&type=style&index=0&id=7143ec35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7143ec35"]])

export default __exports__